<template>
    <div class="user-settings">
        <div class="header">
            <h1>Настройки</h1>
        </div>
        <div v-if="settingsLoading" class="spinner-wrapper">
            <VSpinner />
        </div>
        <div v-else>
            <VForm @submit="saveSettings">
                <div class="settings-block">
                    <div class="settings-block_content">
                        <h2>Настройки интерфейса</h2>
                        <div class="settings-block_content_formWrapper">
                            <div class="settings-block_content_form">
                                <VFormField label="Тип отображения обращений:">
                                    <VueSelect
                                        v-if="displayType !== undefined"
                                        :options="options"
                                        :reduce="(x) => x.value"
                                        class="v-select-light v-select-with-tooltip"
                                        placeholder="Тип отображения обращений"
                                        v-model="displayType"
                                    >
                                        <template #option="option">
                                            <span
                                                class="vselect-option-tooltip"
                                                :data-tooltip="displayTypeTooltips[option.label]"
                                                >{{ option.label }}</span
                                            >
                                        </template>
                                    </VueSelect>
                                </VFormField>
                            </div>
                            <div class="settings-block_content_form">
                                <VFormField label="Количество подгружаемых обращений по умолчанию:">
                                    <VueSelect
                                        :options="requestsCount"
                                        :reduce="(x) => x.value"
                                        class="v-select-light"
                                        placeholder="Количество подгружаемых обращений"
                                        v-model="selectedRequestsCount"
                                    />
                                </VFormField>
                            </div>
                        </div>
                        <div class="settings-block_content_formWrapper settings-block_content_formWrapper_text-size">
                            <div class="settings-block_content_form">
                                <VFormField label="Размер шрифта:">
                                    <VueSelect
                                        :options="textSizeOptions"
                                        :reduce="(option) => option.value"
                                        class="v-select-light"
                                        placeholder="Размер шрифта"
                                        :clearable="false"
                                        :searchable="false"
                                        v-model="selectedTextSize"
                                    />
                                </VFormField>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="settings-block">
                    <div class="settings-block_content">
                        <h2>Настройки модального окна</h2>
                        <div class="settings-block_content_formWrapper">
                            <div class="settings-block_content_form">
                                <VFormField label="Тип селектора:">
                                    <VueSelect
                                        :options="selectorType"
                                        :reduce="(x) => x.value"
                                        class="v-select-light v-select-with-tooltip"
                                        placeholder="Тип селектора"
                                        v-model="selectedSelectorType"
                                    >
                                        <template #option="option">
                                            <span
                                                class="vselect-option-tooltip"
                                                :data-tooltip="selectorTypeTooltips[option.value]"
                                                >{{ option.label }}</span
                                            >
                                        </template>
                                    </VueSelect>
                                </VFormField>
                            </div>
                            <div class="settings-block_content_form">
                                <VFormField label="Отправка сообщений в чате обращения:">
                                    <VueSelect
                                        :options="sendHotkeyType"
                                        :reduce="(x) => x.value"
                                        class="v-select-light v-select-with-tooltip"
                                        placeholder="Отправка сообщений"
                                        v-model="selectedSendHotkey"
                                    >
                                        <template #option="option">
                                            <span
                                                class="vselect-option-tooltip"
                                                :data-tooltip="sendHotkeyTooltips[option.value]"
                                                >{{ option.label }}</span
                                            >
                                        </template>
                                    </VueSelect>
                                </VFormField>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="settings-block">
                    <div class="settings-block_content">
                        <h2>Настройки навигации</h2>
                        <div class="settings-block_content_formWrapper">
                            <div class="settings-block_content_form">
                                <VFormField label="Отображение пунктов меню:">
                                    <VueSelect
                                        :options="navigationOptions"
                                        :reduce="(x) => x.value"
                                        class="v-select-light v-select-with-tooltip"
                                        placeholder="Выберите отображение"
                                        v-model="selectedNavigationType"
                                    >
                                        <template #option="option">
                                            <span
                                                class="vselect-option-tooltip"
                                                :data-tooltip="navigationTooltips[option.value]"
                                                >{{ option.label }}</span
                                            >
                                        </template>
                                    </VueSelect>
                                </VFormField>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="settings-block">
                    <div class="settings-block_content">
                        <h2>Настройки отображения счётчиков</h2>
                        <div class="settings-block_content_form margin_block">
                            <VFormField label="Показывать быстрые фильтры:">
                                <label class="toggle-switch">
                                    <input type="checkbox" v-model="showQuickFilters" />
                                    <span class="slider"></span>
                                </label>
                            </VFormField>
                        </div>
                        <div class="settings-block_content_formWrapper" v-if="showQuickFilters">
                            <div class="settings-block_content_form">
                                <VFormField label="Отображаемые статусы:">
                                    <div class="stats-checkboxes">
                                        <label
                                            v-for="option in statsStatusOptions"
                                            :key="option.value"
                                            class="stats-checkbox"
                                        >
                                            <input
                                                type="checkbox"
                                                :value="option.value"
                                                v-model="selectedStatsStatuses"
                                            />
                                            {{ option.label }}
                                        </label>
                                    </div>
                                </VFormField>
                            </div>
                            <div class="settings-block_content_form">
                                <VFormField label="Просроченные:">
                                    <label class="stats-checkbox">
                                        <input type="checkbox" v-model="showOverdue" />
                                        Отображать просроченные
                                    </label>
                                </VFormField>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="settings-block">
                    <div class="settings-block_content">
                        <h2>Почтовые уведомления</h2>
                        <div class="email-notifications">
                            <label
                                v-for="option in emailNotificationOptions"
                                :key="option.key"
                                class="email-notifications__item"
                            >
                                <span class="email-notifications__label">{{ option.label }}</span>
                                <span class="toggle-switch">
                                    <input type="checkbox" v-model="emailNotifications[option.key]" />
                                    <span class="slider"></span>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="settings-block">
                    <div class="settings-block">
                        <div class="settings-block_content">
                            <div class="settings-block_content_form">
                                <VFormField label="Сезонный интерфейс">
                                    <label class="toggle-switch">
                                        <input type="checkbox" v-model="seasonalInterface" />
                                        <span class="slider"></span>
                                    </label>
                                </VFormField>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="active-form__actions user-settings_submit-button">
                    <div class="button-wrapper">
                        <p class="settings-saved-message" :class="{ visible: showSavedMessage }">
                            ✓ Настройки сохранены
                        </p>
                        <VButton class="button_orange active-form__action" type="submit" :disabled="saving">
                            <span v-if="saving">Сохранение...</span>
                            <span v-else>Сохранить</span>
                        </VButton>
                    </div>
                </div>
            </VForm>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import http from '../../../js/http';

import VForm, { VFormField } from '@/views/components/VForm';
import VButton from '@/views/components/VButton/VButton.vue';
import VSpinner from '@/views/components/VProgress/VSpinner.vue';
import RequestStoreDisplayType from '@/js/enums/RequestStoreDisplayType';
import RequestStoreDisplayTitle from '@/js/enums/RequestStoreDisplayTitle';
import {
    TEXT_SIZE_OPTIONS,
    TEXT_SIZE_SETTING_KEY,
    applyTextSize,
    normalizeTextSize,
    readCachedTextSize,
    rememberTextSize,
    textSizeSetting,
} from '@/js/textSize';
import { EMAIL_NOTIFICATION_OPTIONS, emailNotificationSettings, readEmailNotifications } from '@/js/emailNotifications';

const Account = namespace('account');

const options = Object.keys(RequestStoreDisplayTitle).map((key) => ({
    value: parseInt(key),
    label: RequestStoreDisplayTitle[key],
}));
const requestsCount = [];
for (let i = 5; i <= 100; i += 5) {
    requestsCount.push({ value: i, label: `${i} обращений` });
}

const selectorType = [
    { value: 'combined', label: 'Единое поле категория-сервис' },
    { value: 'separate', label: 'Раздельное поле категория-сервис' },
];
const sendHotkeyType = [
    { value: 'enter', label: 'Enter — отправить, Shift+Enter — перенос строки' },
    { value: 'ctrl-enter', label: 'Ctrl+Enter — отправить, Enter — перенос строки' },
];
const SETTINGS_KEYS = {
    DISPLAY_TYPE: 'request-store.display-type',
    REQUESTS_COUNT: 'request-store.per-page',
    SELECTOR_TYPE: 'request-store.selector-type',
    SEND_HOTKEY: 'request-comment.send-hotkey',
    SEASONAL_INTERFACE: 'request-store.seasonal-interface',
    NAVIGATION_TYPE: 'request-store.navigation-type',
    STATS_VISIBLE_STATUSES: 'request-store.stats-visible-statuses',
    SHOW_OVERDUE: 'request-store.stats-show-overdue',
    SHOW_QUICK_FILTERS: 'request-store.show-quick-filters',
};
const navigationOptions = [
    { value: 'my_only', label: 'Только "Мои обращения"' },
    { value: 'inbox_outbox_archive', label: 'Только "Входящие, Исходящие, Архив"' },
];
const displayTypeTooltips = {
    Карточный: 'Обращения отображаются крупными карточками',
    Табличный: 'Компактный список обращений в виде таблицы',
};
const selectorTypeTooltips = {
    combined: 'Категория и сервис выбираются одним общим полем',
    separate: 'Категория и сервис выбираются раздельно, двумя полями',
};
const sendHotkeyTooltips = {
    'enter': 'Enter отправляет сообщение в чате обращения, Shift+Enter или Ctrl/Cmd+Enter — переносят строку',
    'ctrl-enter': 'Ctrl+Enter или Cmd+Enter отправляют сообщение, Enter и Shift+Enter — переносят строку',
};
const navigationTooltips = {
    my_only: 'В меню будет только раздел «Мои обращения»',
    inbox_outbox_archive: 'В меню будут только разделы «Входящие», «Исходящие» и «Архив»',
};
const NAVIGATION_REDIRECT_ROUTES = {
    my_only: '/request/my',
    inbox_outbox_archive: '/request/inbox',
};
const allStatusOptions = [
    { value: '0', label: 'Закрыто' },
    { value: '1', label: 'Отказано' },
    { value: '2', label: 'Приостановлено' },
    { value: '3', label: 'На уточнении' },
    { value: '4', label: 'В работе' },
    { value: '5', label: 'Выполнено' },
];
@Component({
    components: {
        VForm,
        VFormField,
        VButton,
        VSpinner,
    },
})
class UserSettings extends Vue {
    @Account.State account;

    displayType = RequestStoreDisplayType.CARD;
    selectorType = selectorType;
    sendHotkeyType = sendHotkeyType;
    requestsCount = requestsCount;
    options = options;
    textSizeOptions = TEXT_SIZE_OPTIONS.map(({ value, label }) => ({ value, label }));
    selectedSelectorType = 'combined';
    selectedSendHotkey = 'enter';
    selectedRequestsCount = 15;
    seasonalInterface = false;
    settingsLoading = true;
    saving = false;
    showSavedMessage = false;
    navigationOptions = navigationOptions;
    displayTypeTooltips = displayTypeTooltips;
    selectorTypeTooltips = selectorTypeTooltips;
    sendHotkeyTooltips = sendHotkeyTooltips;
    navigationTooltips = navigationTooltips;
    selectedNavigationType = 'inbox_outbox_archive';
    selectedStatsStatuses = ['0', '1', '2', '3', '4', '5'];
    statsStatusOptions = allStatusOptions;
    showOverdue = true;
    showQuickFilters = false;
    // Выбранный размер виден сразу, ещё до сохранения. savedTextSize — то, что лежит
    // на сервере: к нему страница возвращается, если уйти с неё, не сохранив.
    // Начальное значение — уже применённое при загрузке: если запрос настроек не удастся,
    // уход со страницы не должен сбросить размер на стандартный.
    selectedTextSize = readCachedTextSize();
    savedTextSize = readCachedTextSize();
    // Переключатели живут только на странице: на сервер уходят по «Сохранить», а при
    // следующем открытии читаются с сервера заново — несохранённое теряется само.
    emailNotificationOptions = EMAIL_NOTIFICATION_OPTIONS;
    emailNotifications = readEmailNotifications();

    @Watch('selectedTextSize')
    onTextSizeChange(size) {
        applyTextSize(size);
    }

    get requestStoreSettings() {
        return this.account && this.account.requestStoreSettings
            ? this.account.requestStoreSettings
            : { displayType: RequestStoreDisplayType.CARD };
    }

    saveSettings() {
        this.saving = true;
        this.showSavedMessage = false;

        const settings = [
            { key: SETTINGS_KEYS.DISPLAY_TYPE, value: this.displayType, type: 'string' },
            { key: SETTINGS_KEYS.REQUESTS_COUNT, value: this.selectedRequestsCount, type: 'integer' },
            { key: SETTINGS_KEYS.SELECTOR_TYPE, value: this.selectedSelectorType, type: 'string' },
            { key: SETTINGS_KEYS.SEND_HOTKEY, value: this.selectedSendHotkey, type: 'string' },
            { key: SETTINGS_KEYS.SEASONAL_INTERFACE, value: this.seasonalInterface, type: 'boolean' },
            { key: SETTINGS_KEYS.NAVIGATION_TYPE, value: this.selectedNavigationType, type: 'string' },
            {
                key: SETTINGS_KEYS.STATS_VISIBLE_STATUSES,
                value: JSON.stringify(this.selectedStatsStatuses),
                type: 'string',
            },
            { key: SETTINGS_KEYS.SHOW_OVERDUE, value: this.showOverdue, type: 'boolean' },
            { key: SETTINGS_KEYS.SHOW_QUICK_FILTERS, value: this.showQuickFilters, type: 'boolean' },
            textSizeSetting(this.selectedTextSize),
            ...emailNotificationSettings(this.emailNotifications),
        ];

        http.post('/account-settings/update', { settings })
            .then(() => {
                this.savedTextSize = normalizeTextSize(this.selectedTextSize);
                rememberTextSize(this.savedTextSize);
                this.showSavedMessage = true;
                this.$bus.emit('settings:updated');
                // Сезонный интерфейс применяется сразу: App пишет флаг в localStorage
                // (его же читает экран загрузки с ёлкой) и обновляет снег вживую
                this.$bus.emit('toggleSnow', this.seasonalInterface);
                const targetRoute = NAVIGATION_REDIRECT_ROUTES[this.selectedNavigationType];
                setTimeout(() => {
                    this.showSavedMessage = false;
                    if (targetRoute) {
                        // То же, что redirect() из @/router, но через внедрённый роутер: импорт
                        // синглтона тянул бы Vue.use(VueRouter) в каждого, кто импортирует страницу.
                        this.$router.push(targetRoute);
                    }
                }, 800);
            })
            .catch(() => {
                ///
            })
            .finally(() => {
                this.saving = false;
            });
    }

    async mounted() {
        try {
            const { data } = await http.get('/account-settings');
            if (data[SETTINGS_KEYS.DISPLAY_TYPE]) {
                let parsed = parseInt(data[SETTINGS_KEYS.DISPLAY_TYPE], 10);
                // display-type=3 (старый "Табличный с описанием") больше не существует —
                // трактуем сохранённое ранее значение как обычную таблицу.
                if (parsed === 3) parsed = RequestStoreDisplayType.TABLE;
                this.displayType = parsed;
            } else {
                this.displayType = RequestStoreDisplayType.CARD;
            }
            this.selectedRequestsCount = data[SETTINGS_KEYS.REQUESTS_COUNT] ?? 15;
            this.selectedSelectorType = data[SETTINGS_KEYS.SELECTOR_TYPE] ?? 'combined';
            this.selectedSendHotkey = data[SETTINGS_KEYS.SEND_HOTKEY] ?? 'enter';
            const localSnow = localStorage.getItem('toggleSnow');
            this.seasonalInterface =
                data[SETTINGS_KEYS.SEASONAL_INTERFACE] ?? (localSnow ? JSON.parse(localSnow) : true);
            this.selectedNavigationType = data[SETTINGS_KEYS.NAVIGATION_TYPE] ?? 'inbox_outbox_archive';
            const savedStatuses = data[SETTINGS_KEYS.STATS_VISIBLE_STATUSES];
            this.selectedStatsStatuses = savedStatuses ? JSON.parse(savedStatuses) : ['0', '1', '2', '3', '4', '5'];
            this.showOverdue = data[SETTINGS_KEYS.SHOW_OVERDUE] ?? true;
            this.showQuickFilters = data[SETTINGS_KEYS.SHOW_QUICK_FILTERS] ?? false;
            this.savedTextSize = normalizeTextSize(data[TEXT_SIZE_SETTING_KEY]);
            this.selectedTextSize = this.savedTextSize;
            this.emailNotifications = readEmailNotifications(data);
        } catch (error) {
            //
        } finally {
            this.settingsLoading = false;
        }
    }

    // Несохранённый выбор остаётся предпросмотром: после ухода со страницы интерфейс
    // возвращается к сохранённому размеру, а не живёт до перезагрузки в чужом.
    beforeDestroy() {
        applyTextSize(this.savedTextSize);
    }
}

export default UserSettings;
</script>

<style lang="scss">
.user-settings {
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: auto;
}
.settings-block {
    width: 100%;
    display: flex;
    margin-bottom: 24px;
}
.settings-block_content {
    width: 100%;
}
.settings-block_content_formWrapper {
    width: 100%;
    display: flex;
    gap: 24px;

    &_text-size {
        margin-top: 16px;
    }
}
.settings-block_content_form {
    width: 35%;
    min-width: 200px;
}
.global-actions {
    margin-top: 20px;
}
.stats-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
}
.stats-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 0.9rem;
    input[type='checkbox'] {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }
}
.toggle-switch {
    position: relative;
    display: inline-block;
    margin-left: 12px;
    padding-top: 2px;
    width: 52px;
    height: 28px;
    input {
        opacity: 0;
        width: 0;
        height: 0;
        &:checked + .slider {
            background-color: green;
            &::before {
                transform: translateX(24px);
            }
        }
    }
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        transition: 0.3s;
        border-radius: 34px;
        &::before {
            position: absolute;
            content: '';
            height: 22px;
            width: 22px;
            left: 3px;
            bottom: 3px;
            right: 5px;
            background-color: white;
            transition: 0.3s;
            border-radius: 50%;
        }
    }
}
// Подпись тянется и переносится, переключатель фиксированной ширины не сжимается —
// при крупном размере текста длинные названия уходят на вторую строку, а не под тумблер.
.email-notifications {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 640px;
    margin-top: 8px;

    &__item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        cursor: pointer;
    }

    &__label {
        flex: 1 1 auto;
        min-width: 0;
        font-size: 0.9rem;
        line-height: 1.4;
        overflow-wrap: anywhere;
    }

    .toggle-switch {
        flex: 0 0 auto;
        margin-left: 0;
    }
}
.user-settings_submit-button {
    width: 30%;
    position: relative;
    margin-top: 0;
}

.spinner-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
}
.button-wrapper {
    width: 100%;
    margin-top: -70px;
}
.settings-saved-message {
    color: green;
    font-size: 0.9rem;
    text-align: center;
    margin-bottom: 8px;
    opacity: 0;
    transition: opacity 0.3s;
    &.visible {
        opacity: 1;
    }
}
.margin_block {
    margin-bottom: 1rem;
}
.vselect-option-tooltip {
    position: relative;
    display: block;
    width: 100%;
}
.vselect-option-tooltip::after {
    content: attr(data-tooltip);
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    width: 220px;
    padding: 8px 10px;
    border-radius: 6px;
    background-color: #2b2f36;
    color: #fff;
    font-size: 12px;
    line-height: 1.4;
    white-space: normal;
    text-align: left;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease, visibility 0.15s ease;
    pointer-events: none;
    z-index: 20;
}
.vselect-option-tooltip:hover::after {
    opacity: 1;
    visibility: visible;
}
.v-select-with-tooltip .vs__dropdown-menu {
    overflow: visible !important;
}
@media (max-width: $mobile-breakpoint) {
    .settings-block_content_formWrapper {
        flex-direction: column;
        gap: 0;
    }
    .settings-block_content_form {
        width: 100%;
    }

    .user-settings_submit-button {
        width: 100%;
    }

    .button-wrapper {
        margin-top: 0;
    }
}
</style>
